import React from "react";
// import "./style.css"
import { Tooltip } from "@mantine/core";
import { RiQuestionLine } from "react-icons/ri";

// const ToolTip = ({ toolTipContent }) => {
//   return (
//     <>
//       {toolTipContent && (
//         <div className="tooltip cursor-help">
//           <FaExclamationCircle />
//           <span className="toolTipContent text-xs">{toolTipContent}</span>
//         </div>
//       )}
//     </>
//   )
// }

// export default ToolTip

const ToolTip = ({ toolTipContent, children, className, icon }) => {
  return (
    <Tooltip withArrow label={toolTipContent} className={className || ""}>
      {children || (
        <div className='text-lg'>{!icon ? <RiQuestionLine /> : icon}</div>
      )}
    </Tooltip>
  );
};

export default ToolTip;
